import { TranslatableText } from '@dreryk/react-common';

import { PatientEntitlementToMedicalServiceStatusVerificationState } from '~libs.shared.patient-entitlement-to-medical-service';

import { translationKeys } from '../translations';

export const getPatientEntitlementToMedicalServiceStatusTooltipText = (
   state: PatientEntitlementToMedicalServiceStatusVerificationState
): TranslatableText => {
   if (state.verifing) {
      return translationKeys.synchronization;
   }

   return translationKeys.patientEntitlementStatusMessageMap[state.status];
};
